import * as THREE from 'three';
import { createEntityId } from '../types';
import type { EntityId } from '../types';

export abstract class Entity {
  readonly id: EntityId;
  readonly object3D: THREE.Object3D;
  private alive = true;

  constructor() {
    this.id = createEntityId();
    this.object3D = new THREE.Group();
    this.object3D.name = this.constructor.name;
  }

  onSpawn(): void {}
  onDespawn(): void {}
  update(_dt: number): void {}

  get isAlive(): boolean {
    return this.alive;
  }

  markForRemoval(): void {
    this.alive = false;
  }
}
